module.exports = __webpack_public_path__ + "img/horizontal_4_6_pp13_5012.0eaa2fba.png";